function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.9492 13.5L46.0594 18.5345V26.4185L40.7293 28.1536V20.6604L23.9583 15.3141L29.9492 13.5Z",
  fill: "#E6123D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7164 13.4809L46.9304 18.6615C47.28 18.7732 47.5173 19.0982 47.5173 19.4653V26.3065C47.5173 26.6642 47.2918 26.983 46.9546 27.1021L45.3699 27.6618C44.9305 27.817 44.4485 27.5866 44.2933 27.1472C44.1381 26.7078 44.3685 26.2258 44.8079 26.0706L45.8298 25.7097V20.0814L27.7739 14.3123C26.9997 14.0649 26.9885 12.9735 27.7574 12.7103L33.6976 10.6767C33.8681 10.6184 34.0529 10.6161 34.2248 10.6704L53.1248 16.6342C53.4759 16.745 53.7146 17.0706 53.7146 17.4388V38.0142C53.7146 38.3822 53.4762 38.7077 53.1253 38.8187L34.2253 44.7975C34.0587 44.8502 33.8799 44.8498 33.7135 44.7965L15.0491 38.8178C14.6998 38.7059 14.4628 38.3811 14.4628 38.0142V35.2294C14.4628 34.7634 14.8405 34.3856 15.3065 34.3856C15.7725 34.3856 16.1503 34.7634 16.1503 35.2294V37.3985L33.9725 43.1075L52.0271 37.3962V18.0573L33.9816 12.3632L30.7164 13.4809Z",
  fill: "#424750"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M52.6164 16.7455C53.0607 16.605 53.5348 16.8512 53.6753 17.2955C53.8159 17.7398 53.5696 18.2139 53.1253 18.3545L34.2253 24.3332C34.0593 24.3857 33.8811 24.3856 33.7152 24.3328L19.2918 19.7459C18.8477 19.6047 18.6022 19.1302 18.7434 18.6861C18.8847 18.2421 19.3591 17.9966 19.8032 18.1378L33.9715 22.6436L52.6164 16.7455Z",
  fill: "#424750"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M42.3923 26.8191C42.8348 26.673 43.3119 26.9132 43.4581 27.3557C43.6042 27.7982 43.364 28.2753 42.9215 28.4215L40.8408 29.1087C40.2949 29.289 39.7324 28.8824 39.7324 28.3075V22.0824L21.6765 16.3132C20.8982 16.0645 20.8924 14.9654 21.668 14.7085L28.7559 12.3615C29.1982 12.215 29.6756 12.4549 29.8221 12.8973C29.9686 13.3396 29.7287 13.817 29.2863 13.9635L24.6607 15.4952L40.833 20.6625C41.1826 20.7742 41.4199 21.0991 41.4199 21.4662V27.1402L42.3923 26.8191Z",
  fill: "#424750"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1455 18.2049V22.2706C16.1455 22.7365 15.7677 23.1143 15.3017 23.1143C14.8358 23.1143 14.458 22.7365 14.458 22.2706V17.5854C14.458 17.2168 14.6973 16.8909 15.049 16.7804L21.7528 14.6755C22.1974 14.5359 22.671 14.7832 22.8106 15.2278C22.9502 15.6723 22.7029 16.1459 22.2584 16.2855L16.1455 18.2049Z",
  fill: "#424750"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2715 24.1313C23.7375 24.1313 24.1153 24.509 24.1153 24.975C24.1153 25.441 23.7375 25.8188 23.2715 25.8188H8.09575C7.62976 25.8188 7.252 25.441 7.252 24.975C7.252 24.509 7.62976 24.1313 8.09575 24.1313H23.2715Z",
  fill: "#19BFD3"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8341 27.8438C15.3 27.8438 15.6778 28.2215 15.6778 28.6875C15.6778 29.1535 15.3 29.5312 14.8341 29.5312H1.68326C1.21727 29.5312 0.839508 29.1535 0.839508 28.6875C0.839508 28.2215 1.21727 27.8438 1.68326 27.8438H14.8341Z",
  fill: "#19BFD3"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.5645,
  cy: 24.975,
  r: 0.84375,
  fill: "#19BFD3"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.927,
  cy: 32.4,
  r: 0.84375,
  fill: "#19BFD3"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8841 31.5562C19.35 31.5562 19.7278 31.934 19.7278 32.4C19.7278 32.866 19.35 33.2437 18.8841 33.2437H10.4583C9.99226 33.2437 9.6145 32.866 9.6145 32.4C9.6145 31.934 9.99226 31.5562 10.4583 31.5562H18.8841Z",
  fill: "#19BFD3"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3215 9.28125C27.7875 9.28125 28.1653 9.65901 28.1653 10.125C28.1653 10.591 27.7875 10.9688 27.3215 10.9688H14.1707C13.7048 10.9688 13.327 10.591 13.327 10.125C13.327 9.65901 13.7048 9.28125 14.1707 9.28125H27.3215Z",
  fill: "#19BFD3"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1591 13.3312C14.625 13.3312 15.0028 13.709 15.0028 14.175C15.0028 14.641 14.625 15.0187 14.1591 15.0187H7.75826C7.29226 15.0187 6.91451 14.641 6.91451 14.175C6.91451 13.709 7.29226 13.3312 7.75826 13.3312H14.1591Z",
  fill: "#19BFD3"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M34.927 43.9172C34.927 44.3832 34.5492 44.7609 34.0833 44.7609C33.6173 44.7609 33.2395 44.3832 33.2395 43.9172V39.7439C33.2395 39.2779 33.6173 38.9001 34.0833 38.9001C34.5492 38.9001 34.927 39.2779 34.927 39.7439V43.9172Z",
  fill: "#424750"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M34.927 36.3534C34.927 36.8194 34.5492 37.1972 34.0833 37.1972C33.6173 37.1972 33.2395 36.8194 33.2395 36.3534V24.3C33.2395 23.834 33.6173 23.4562 34.0833 23.4562C34.5492 23.4562 34.927 23.834 34.927 24.3V36.3534Z",
  fill: "#424750"
});

function SvgExpressDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressDelivery);
export default __webpack_public_path__ + "static/media/express-delivery.17faf1c5.svg";
export { ForwardRef as ReactComponent };